import { render, staticRenderFns } from "./VenueSelect.vue?vue&type=template&id=38931933&"
import script from "./VenueSelect.vue?vue&type=script&lang=js&"
export * from "./VenueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VenueSelect.vue"
export default component.exports